(function () {
  angular
    .module("akitabox.desktop.request.detail")
    .controller("RequestRoomTabController", RequestRoomTabController);

  /* @ngInject */
  function RequestRoomTabController(
    $timeout,
    building,
    request,
    RoomService,
    ToastService
  ) {
    var self = this;

    // Attributes
    self.loading = true;
    self.rendering = true;
    self.building = building;
    self.request = request;
    self.room = null;

    init();

    function init() {
      var roomId = self.request.room._id;
      var params = { include_values: true };
      var options = {
        includePinType: true,
        includeFloor: true,
      };
      RoomService.getById(building._id, roomId, params, options)
        .then(function (room) {
          self.room = room;
        })
        .catch(ToastService.showError)
        .finally(function () {
          self.loading = false;
          $timeout(function () {
            self.rendering = false;
          }, 500);
        });
    }
  }
})();
